import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import moment from 'moment'
import { normalize } from 'normalizr'
import _ from 'lodash'
import { viewConstants } from './../_constants/view.constants'
import { leaveSchema } from './../entities/schema'

export const employeeLeaveService = {
    fetchEmployeeLeave,
}

function convertViewModelList(data) {
    let viewModel = []
    if (!_.isEmpty(data) && _.isArray(data)) {
        data.map(o => {
            const m = {}
            m.id = o.LeaveID
            m.Title = o.title
            m.start = moment(o.PayrollEmpLeaveDate).toDate()
            m.end = moment(o.PayrollEmpLeaveEndDate).toDate()
            m.EmployeeID = o.PayrollEmpLeaveEmployeeID
            m.PayrollEmpLeavePeriodID = o.LeaveID
            m.ActionType = o.LeaveType
            m.Note = o.PayrollEmpLeaveReason
            m.hours = o.PayrollEmpLeaveHours ? parseFloat(parseFloat(o.PayrollEmpLeaveHours).toFixed(2)) : 0
            m.PayrollEmpLeaveTypeID = o.PayrollEmpLeaveTypeID
            m.PayrollEmpLeavePeriod = o.PayrollEmpLeavePeriod

            // Set showRecord default to true
            m.showRecord = true

            // Apply approval logic based on PayrollEmpLeaveApproved
            // PayrollEmpLeaveApproved can be 1 (approved) or 0 (not approved)
            if (o.PayrollEmpLeaveApproved === 1 || o.PayrollEmpLeaveApproved === true) {
                m.approved = true
            } else {
                m.approved = false
            }

            // Only add to viewModel if showRecord is true
            if (m.showRecord) {
                viewModel.push(m)
            }
        })
    }

    const leaveListSchema = [leaveSchema]
    const normalizedData = normalize(viewModel, leaveListSchema)
    return normalizedData.entities
}

function fetchEmployeeLeave(options) {
    const url = '/api/leave'

    const defaultQueryCond = {
        range: viewConstants.MONTH,
        time: new Date(),
    }

    let queryCond = Object.assign({}, defaultQueryCond, options)

    return httpClient
        .post(url, queryCond)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}
